import { GetterTree } from 'vuex';
import { InvoiceState, RootState } from '@/store/types';
import { Invoice } from '@/models/invoice';
import { InvoiceListItem } from '@/models/invoice-list-item';

const getters: GetterTree<InvoiceState, RootState> = {
  getInvoice(state: InvoiceState): Invoice {
    return state.invoice;
  },
  getInvoices: (state: InvoiceState): InvoiceListItem[] => {
    return state.invoicesList;
  },
  getSearch: (state: InvoiceState): string => {
    return state.search;
  },
};

export default getters;
